import { html, View } from 'rune-ts';
import klass from './ItemSoldNowCoverBannerView.module.scss';
import { font } from '../../../../shared/typography';
import { CoverBanner } from '../../../components/atoms/CoverBanner/CoverBanner';

export type ItemSoldNowCoverBannerViewData = {
  is_mobile: boolean;
};

export class ItemSoldNowCoverBannerView extends View<Readonly<ItemSoldNowCoverBannerViewData>> {
  private static readonly KeyVisual = CoverBanner.resizeImage(
    '//s3.marpple.co/files/u_2232571/2025/3/original/ce804de9ca78bb1964fddbcb03305a84abe5ff9d1.png',
  );

  override template() {
    return this.data.is_mobile ? this.moTemplate() : this.pcTemplate();
  }

  private pcTemplate() {
    return html`<div class="${klass.cover_banner}">
      <div class="${klass.title_container} ${CoverBanner.typo.pc}">
        <span class="${klass.text}">ITEM</span>
        ${this.makeImageTmpl()}
        <span class="${klass.text}">SOLD NOW!</span>
      </div>
      <div class="${klass.right}">
        <span class="${font('16_bold')}"> ${CoverBanner.toText(ET('mps2::recently_sold::desc'))}</span>
      </div>
    </div>`;
  }

  private moTemplate() {
    return html`<div class="${klass.cover_banner}">
      ${this.makeImageTmpl()}
      <span class="${klass.text} ${CoverBanner.typo.mobile}">${CoverBanner.toText('ITEM SOLD\nNOW')}</span>
    </div>`;
  }

  private makeImageTmpl() {
    return html`<span class="${klass.image_container}">
      <img alt="" class="${klass.image}" src="${ItemSoldNowCoverBannerView.KeyVisual}" />
    </span>`;
  }
}
